export const queryKeys = {
  all: ["rentmaadi"] as const,
  properties: () => [...queryKeys.all, "properties"] as const,
  propertyDetail: (id: string | null) => [...queryKeys.properties(), id ?? "none"] as const,
  propertyRent: (propertyId: string, year: number) =>
    [...queryKeys.propertyDetail(propertyId), "rent", year] as const,
  propertyExpenses: (propertyId: string, from: string, to: string) =>
    [...queryKeys.propertyDetail(propertyId), "expenses", from, to] as const,
  dashboardSummary: () => [...queryKeys.all, "dashboard", "summary"] as const,
  rentRecords: (filters: { year?: number; month?: number; propertyId?: string }) =>
    [...queryKeys.all, "rent", filters] as const,
  unitDetail: (unitId: string) => [...queryKeys.all, "units", unitId] as const,
  expenses: (filters: { propertyId?: string; unitId?: string; from?: string; to?: string }) =>
    [...queryKeys.all, "expenses", filters] as const,
  tenantDashboard: () => [...queryKeys.all, "tenant", "dashboard"] as const,
};
